export interface MenuRect { left: number; right: number; top: number; bottom: number }
export interface MenuSize { width: number; height: number }
export interface MenuViewport { width: number; height: number }

export function sidebarMenuPlacement(trigger: MenuRect, menu: MenuSize, viewport: MenuViewport): { left: number; top: number; maxHeight: number; above: boolean } {
  const margin = 8;
  const gap = 4;
  const width = Math.min(menu.width, Math.max(0, viewport.width - margin * 2));
  const left = Math.max(margin, Math.min(trigger.right - width, viewport.width - margin - width));
  const below = Math.max(0, viewport.height - margin - trigger.bottom - gap);
  const above = Math.max(0, trigger.top - margin - gap);
  const openAbove = below < menu.height && above > below;
  const available = openAbove ? above : below;
  const maxHeight = Math.min(menu.height, Math.max(40, available), Math.max(0, viewport.height - margin * 2));
  const top = openAbove ? Math.max(margin, trigger.top - gap - maxHeight) : Math.min(viewport.height - margin - maxHeight, trigger.bottom + gap);
  return { left, top: Math.max(margin, top), maxHeight, above: openAbove };
}

export function positionSidebarMenu(menu: HTMLElement, trigger: HTMLElement, viewport: MenuViewport): void {
  menu.hidden = false;
  menu.classList.add("is-positioned");
  menu.style.visibility = "hidden";
  menu.style.maxHeight = "";
  menu.style.top = "0px";
  menu.style.left = "0px";
  const box = menu.getBoundingClientRect();
  const placement = sidebarMenuPlacement(trigger.getBoundingClientRect(), { width: box.width, height: menu.scrollHeight }, viewport);
  menu.style.left = `${placement.left}px`;
  menu.style.top = `${placement.top}px`;
  menu.style.maxHeight = `${placement.maxHeight}px`;
  menu.style.visibility = "";
  menu.dataset.placement = placement.above ? "above" : "below";
}
